interface StarsProps {
  rating: number;
  size?: 'sm' | 'md';
}

export default function Stars({ rating, size = 'md' }: StarsProps) {
  const full = Math.floor(rating);
  const half = rating - full >= 0.5;
  const iconSize = size === 'sm' ? 'text-xs' : 'text-sm';

  return (
    <span className="flex items-center gap-0.5 text-amber-500">
      {Array.from({ length: 5 }).map((_, i) => {
        const cls =
          i < full ? 'ri-star-fill' : i === full && half ? 'ri-star-half-line' : 'ri-star-line';
        return (
          <span key={i} className={`${iconSize} w-[1em] h-[1em] flex items-center justify-center`}>
            <i className={cls}></i>
          </span>
        );
      })}
    </span>
  );
}